import colors from "colors";
import { IconProps } from "./types";

export default function IcoSearch({
	color = colors.neutral["low-pure-500"]
}: Readonly<IconProps>) {
	return (
		<svg
			width="13"
			height="14"
			viewBox="0 0 13 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.92411 10.3538L12.4979 12.9969M6 1C9.03757 1 11.5 3.46244 11.5 6.50001C11.5 9.53757 9.03757 12 6 12C2.96243 12 0.5 9.53757 0.5 6.50001C0.5 3.46244 2.96243 1 6 1Z"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
